import React, {useEffect, useState, useRef, createRef} from 'react';
import styled from '@emotion/styled';
import {getCustomerOrders, getCustomerProfile, getResourceFile, updateCustomerProfile} from '../../network';
import {connect} from 'react-redux';
import {dateFormatter, formatCurrency, formatPrice} from '../../helpers/Helper';
import {Checkbox} from 'semantic-ui-react';
import {formatDate, formatPhoneNumber, padding} from '../../utils/formatter';
import PaginationComponent from '../shared/PaginationComponent';
import {setUser} from '../../redux/actions/UserActions';
import Konva from 'konva';
import {Stage, Layer, Circle} from 'react-konva';
import _ from 'lodash';
import LoadingComponent from '../shared/LoadingComponent';
import DotsComponent from '../shared/DotsComponent';
import MaskedInputComponent from '../shared/MaskedInputComponent';
import DropdownContainer from '../shared/DropdownComponent';
import CustomCheckbox from '../shared/CheckboxComponent';

const {lerp} = require('canvas-sketch-util/math');
const random = require('canvas-sketch-util/random');

const Layout = styled.div`
    display: grid;
    grid-gap: var(--space-56);
    grid-auto-flow: column;
    
    align-items: flex-start;
    
    margin-top: 5rem;
    margin-bottom: 6rem;

    @media (max-width: 800px){
        grid-gap:0rem;
        align-items:center;
    }
  
`;

const ProfileContainer = styled.div`
    display: grid;
    grid-auto-flow: row;

    @media (max-width: 800px){
        //display:none;
        justify-self:center;
    }
`;

const OrderContainer = styled.div`
    position:relative;
    display: grid;
    grid-auto-flow: row;
    width: inherit;
    
`;

const LayoutHeader = styled.h1`
    margin-bottom: var(--space-48);
    margin-left: var(--space-32);
    
    font-style: normal;
    font-weight: 500;
    font-size: var(--font-32);
    line-height: var(--space-32);
    
    color: var(--company-dark);

    @media (max-width: 800px){
        display:none;
    }
`;

const EditLayout = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    
    width: 100%;
    
    margin-bottom: var(--space-24);
    
    > span {
        font-weight: normal;
        font-style: normal;
        font-size: var(--font-16);
        line-height: var(--font-16);
        
        color: black;
    }
`;

const TopOrderLayout = styled.div`
    display: flex;
    flex-direction: column;
    width: auto;
    justify-content: space-between;

    > span {
        font-weight: normal;
        font-style: normal;
        font-size: var(--font-16);
        line-height: var(--font-16);
        align-self: flex-end;
        color: black;
    }
  
`;

const TopSortLayout = styled.div`
    display: flex;
    flex-direction: column;
    width: auto;
    justify-content: space-between;

    > span {
        font-weight: normal;
        font-style: normal;
        font-size: var(--font-16);
        line-height: var(--font-16);
        align-self: flex-end;
        color: black;
    }
    @media (max-width: 800px){
        flex-direction: column;
       
    }
    @media (max-width:500px){
        flex-direction: row;
        span{
            align-self: center;
        }
        
    }
    @media (max-width:400px){
        flex-direction: row;
       
    }
`;

const Card = styled.div`
    display: grid;
    grid-auto-flow: row;
    
    /* width: 21rem; */
    
    padding: var(--space-40);

    box-shadow: var(--card-shadow-large);
    border-radius: var(--space-18);
    background-color: var(--color-white);

    .header{
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        margin-bottom: 2rem;
    }

    @media (max-width: 800px){
        box-shadow:none;
        border-radius:0px;
        padding: 0;
        width: 90vw;
    }
    @media (max-width:500px){
        .header{
            height: 8rem;
            flex-direction:column;
            justify-content: space-between;
        }
       
    }
`;

const Header = styled.h1`
    font-style: normal;
    font-weight: 500;
    font-size: var(--font-24);
    line-height: var(--space-24);
    
    color: black;
    
    margin-bottom: var(--space-14);
`;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    
    background: var(--color-gray-300);
`;

const Title = styled.p`
    margin-top: var(--space-32);
    
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-14);
    line-height: var(--space-16);
    
    color: var(--color-gray-600);
`;

const Text = styled.p`
    margin-top: var(--space-8);
    
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-18);
    line-height: var(--space-22);
    
    color: var(--color-gray-900);
`;

const CheckboxRow = styled.div`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    justify-content: space-between;
    grid-gap: var(--space-28);
    
    width: 100%;
    
    margin-bottom: var(--space-24);
    
    > label {
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-14);
        line-height: var(--space-14);
        
        color: var(--color-neutral-gray-700);
    }
`;

const EditProfileTextInput = styled.input`
    border: none;
    border-bottom: 1px solid var(--color-gray-600);
    
    margin-top: var(--space-8);
    padding-bottom: var(--space-4);
    
    font-size: var(--font-18);
    line-height: 1.375rem;
    
    color: var(--color-gray-900);
    
    :focus {
        outline: none;
    }
`;

const EditProfileDropdown = styled.select`
    border: none;
    border-bottom: 1px solid var(--color-gray-800);
    
    margin-top: var(--space-8);
    padding-bottom: var(--space-4);
    
    font-size: var(--font-18);
    line-height: 1.375rem;
    
    color: var(--color-gray-900);
    background: none;
    
    :focus {
        outline: none;
    }
`;

const Search = styled.input`
    max-width: 20rem;
    height: var(--space-32);
    
    padding: var(--space-10);
    background: white;
    color: var(--color-gray-500);
    
    font-size: var(--font-14);
    line-height: var(--font-14);
    
    border: 1px solid var(--color-neutral-gray-400);
    box-sizing: border-box;
    border-radius: var(--space-4);

    background-image: url(/icons/search-icon.svg);
    background-repeat: no-repeat;
    background-position: right 1rem top 50%;

    @media (max-width: 500px){
        width: auto;
    }
  
`;

const HorizontalLayout = styled.div`
    display: flex;
    flex-direction: row;
    width: 13rem;
    
    justify-content: space-between;
    align-self: flex-end;
    @media (max-width: 800px){
        /* width: 105%; */
        align-self: flex-end;
    }
    @media (max-width: 500px){
        /* width: 64%; */
        align-self: auto;
    }
    /* @media (max-width: 400px){
        width: 65%;
    } */
`;

const Filter = styled.select`
    display: flex;
    flex-direction: row;
    align-items: center;
    
    width: 6rem;
    height: var(--space-32);
    
    font-size: var(--font-14);
    line-height: var(--font-14);
    
    color: var(--color-neutral-gray-900);
    
    background: white;

    border: 1px solid var(--color-neutral-gray-400);
    box-sizing: border-box;
    border-radius: var(--space-6);

    padding-left:var(--space-8);
    -webkit-appearance:none;
    background-image: url(/icons/chevron.svg);
    background-repeat: no-repeat;
    background-position-x: 4rem;
    background-position-y:center;

`;
const OverviewLineItem = styled.div`
    display: flex;
    align-items: center;
    
    width: inherit;
    height: var(--space-64);

    background: ${props => props.selected ? 'var(--color-gray-100)' : 'white'};
    border-radius: ${props => props.selected ? 'var(--space-10)' : ''};
    border-bottom: ${props => props.selected ? '' : '1px solid var(--color-gray-300)'};
    
    transition: background-color 0.3s ease-in, border-bottom-color 0.3s ease-in;
    
    cursor: pointer;
    
    > div.details {
        display: grid;
        width: auto;
        grid-auto-flow: column;
        grid-gap: 5%;

        .OrderRow{
            display: flex;
            flex-direction: row;
            width:15rem;
            justify-content:space-between;
        }
        .PriceRow{
            display: flex;
            flex-direction: row;
            width:15rem;
            justify-content:space-between;
        }
        
        .order {
            font-style: normal;
            font-weight: 600;
            font-size: var(--font-14);
            line-height: var(--font-14);
            text-transform: uppercase;
            
            color: var(--color-gray-600);
        }
        
        .new {
            font-style: normal;
            font-weight: 600;
            font-size: var(--font-14);
            line-height: var(--font-14);
            text-transform: uppercase;
            text-align: right;
            
            color: var(--color-orange-600);
        }

        .cancelled {
            font-style: normal;
            font-weight: 600;
            font-size: var(--font-14);
            line-height: var(--font-14);
            text-transform: uppercase;
            text-align: right;
            
            color: var(--color-red-600);
        }
        
        .open {
            font-style: normal;
            font-weight: 600;
            font-size: var(--font-14);
            line-height: var(--font-14);
            text-transform: uppercase;
            text-align: right;
    
            color: var(--color-green-600);
        }
        
        .fulfilled {
            font-style: normal;
            font-weight: 600;
            font-size: var(--font-14);
            line-height: var(--font-14);
            text-transform: uppercase;
            text-align: right;
    
            color: var(--color-gray-700)
        }
        
        .price, .date {
            font-style: normal;
            font-weight: normal;
            font-size: var(--font-14);
            line-height: var(--font-14);
            text-align: right;
            
            color: var(--color-gray-700);
        }
    }
    @media (max-width:500px){
      
        > div.details{
            display: flex;
            flex-direction: row;
            height: 2.5rem;
            justify-content: space-between;
        .OrderRow{
            width: 11rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: baseline;
        }
        .PriceRow{
            width: 10rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: baseline;
        }
    }
    }

`;

const ChevronImage = styled.img`
    display: flex;
    transition: 0.3s ease-in;
    transform: ${props => props.selected ? '' : 'rotate(90deg)'};

    @media (max-width: 800px){
        margin-left: 4rem;
    }

    @media (max-width: 500px){
        margin-left: 0rem;
        padding-top: 0.5rem;
        position:absolute;
        right: 1rem;

    }

`;

const SelectedOrderContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: auto;
    padding: var(--space-24) var(--space-24) var(--space-40) var(--space-24);
    
    .details {
        display: flex;
        flex-direction: column;
        
        > span {
            font-style: normal;
            font-weight: normal;
            font-size: var(--font-14);
            line-height: var(--font-18);
            
            color: var(--color-gray-900);
            
            margin-bottom: var(--space-8);
            
            > b {
                font-weight: 600;
            }
        }
        
        > span.price {
            font-style: normal;
            font-weight: 500;
            font-size: var(--font-14);
            line-height: var(--font-14);
            
            text-align: right;
            
            color: var(--color-orange-600);
            white-space: nowrap;
        }
        
        > span.quantity {
            font-style: normal;
            font-weight: 500;
            font-size: var(--font-12);
            line-height: var(--font-12);
            
            text-align: right;
            
            color: var(--color-gray-600);
        }
    }
    
    .configuration {
        order: 1;
    }
    
    .pricing {
        order: 2
    }
    
    .buttons {
        display: flex;
        flex-direction: row;
        
        justify-content: flex-end;
        
        button {
            border: none;
            box-shadow: none;
            background: none;
            padding: 0;
            
            margin-left: var(--space-24);
            
            color: var(--color-gray-700);
            
            font-style: normal;
            font-size: var(--font-14);
            line-height: var(--font-14);
            font-weight: 500;
        }
        
        &:first-of-type {
            margin-left: 0;
        }
        
        button.repeat {
            color: var(--company-dark);
        }
        
        button.cancel {
            color: var(--color-red-700);
        }
    }
    @media (max-width:500px){
      
    }
    @media (max-width: 400px){
   
    }
`;

const SelectedOrderLineItem = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: var(--space-64) auto;
    grid-gap: 1rem;
    
    width: auto;
    
    padding-bottom: var(--space-24);
    margin-bottom: var(--space-16);
    
    border-bottom: 1px dashed var(--color-gray-300);
`;

const ProductImageContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    width: var(--space-64);
    height: var(--space-64);

    background: white;

    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: var(--space-8);
    
    > .badge {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        color: #000;
        width: auto;
        /* height: var(--space-18); */
        min-width: var(--space-18);
        
        font-size: var(--font-12);
        line-height: var(--font-12);
        
        background: white;
        border: 1px solid var(--color-gray-500);
        box-sizing: border-box;
        box-shadow: none;
        
        border-radius: 0.625rem;
        left: 3.25rem;
        top: 3.25rem;
        margin: 0;
    }
    
    > img {
        width: 90%;
        height: 90%;
        object-fit: contain;
        padding: 0.25rem;
    }
`;

const PaginationContainer = styled.div`
    width: 10rem;
    margin-top: var(--space-48);
`;

const ActionsBar = styled.div`
    display: flex;
    align-items: center;
    margin-top: auto;
    justify-content: space-between;
    padding-top: var(--space-32);
    //padding-left: var(--space-20);
    //padding-right: var(--space-20);
    //padding-bottom: var(--space-8);
    border-top: 1px solid var(--color-gray-300);
    
    margin-left: -2.5rem;
    margin-right: -2.5rem;
    
    > button {
        border: none;
        box-shadow: none;
        background: none;
        //padding: var(--space-6) var(--space-8);
        padding: 0;
        border-radius: var(--space-4);
        color: var(--color-gray-700);
        
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-16);
        line-height: var(--font-16);
        
        &:first-of-type {
            margin-left: var(--space-40);;
        }
        
        &:last-of-type {
            margin-right: var(--space-40);
        }
        
        &:disabled {
            color: var(--color-gray-400);
            cursor: not-allowed;
        }
        
        &:hover {
            color: var(--color-gray-500);
            transition: color 0.3s ease-in;
        }
    }
`;
const MainContainer = styled.div`
    display:none;
    position: sticky;
    margin-top:5rem;
   
    z-index: 1;
    @media (max-width:800px){
        display:flex;
    }
`;
const Container = styled.div`

    display: grid;
    grid-gap: 1rem;
    grid-auto-flow: column;
    width: 20rem;
    justify-content: flex-start;
    padding-top: 0.1rem;
    .active{
        content:none;
        color:var(--color-gray-800);
        background-color: var(--color-white);
        font-weight:normal;
        cursor:default;
        
    }
    .next--active{
        content:none;
        color:var(--color-gray-800);
        background-color: var(--color-white);
        font-weight:normal;
        cursor:default;
        
    }
    .active:before{
         position: absolute;
         width: var(--space-8);
         height: var(--space-12);
         top: 1.6rem;
        right: 5.8rem;
         content:" ";
       
         background-color: transparent;
         border-radius: 0px 0px 8px 0px;
         box-shadow: 0px 6px 0px 0px var(--color-white);
     }

     .active:after{
         position: absolute;
         width: var(--space-8);
         height: var(--space-12);
         top: 1.6rem;
         left: 5.8rem;
         content:" ";

         background-color: transparent;
         border-radius: 0px 0px 0px 8px;
         box-shadow: 0px 6px 0px 0px var(--color-white);
     }

    .next--active:before{
         position: absolute;
         width: var(--space-8);
         height: var(--space-12);
         top: 1.6rem;
         right: 6.05rem;
         content:" ";
       
         background-color: transparent;
         border-radius: 0px 0px 8px 0px;
         box-shadow: 0px 6px 0px 0px var(--color-white);
     }

     .next--active:after{
         position: absolute;
         width: var(--space-8);
         height: var(--space-12);
         top: 1.6rem;
         left: 6.05rem;
         content:" ";

         background-color: transparent;
         border-radius: 0px 0px 0px 8px;
         box-shadow: 0px 6px 0px 0px var(--color-white);
     }
  
`;
const VerticalContainer = styled.div`
    display:grid;
    grid-gap:2.5rem;
    grid-auto-flow:row;

 
`;
const ProfileHeader = styled.a`
    position: relative;
    white-space: nowrap;
    cursor: pointer;
    grid-row-start:1;
    padding: 12px 16px;
    justify-content: center;
    border-radius: 8px 8px 0px 0px;
    height: var(--space-44);
    font-size: var(--space-14);
    font-weight: 500;
    background-color:var(--company);
    color:var(--color-white);
 
`;

const ProfileHead = styled.a`
    position:relative;
    white-space:nowrap;
    cursor:pointer;
    grid-row-start:1;
    padding: 12px 16px;
    justify-content:center;
    border-radius: 8px 8px 0px 0px;
    height: var(--space-44);
    font-size: var(--space-14);
    font-weight: 500;
    background-color:var(--company);
    color:var(--color-white);

    
  

    
`;


const Head = styled.h1`
    font-weight: 500;
    font-size: var(--font-40);
    line-height: var(--space-40);
    color:var(--company-dark);

    @media (max-width: 500px){
        position: relative;
        top: -4rem;
        font-size: var(--font-28);
    }
`;

const HeaderBackground = styled.div`
    display:none;
    background: linear-gradient(180deg, #F0F3F4 0%, rgba(255, 255, 255, 0) 100%);
    border-radius: 0px 0px 0px 0px;
    transform: matrix(1, 0, 0, -1, 0, 0);
    width:100%;
    height:12.5rem;
    position:absolute;
    left:0rem;
    z-index:-1;

    @media (max-width:800px){
        display:flex;
    }
`;

const Gradient = styled.div`
    display:none;
    position: absolute;
    width: 100%;
    height: 80px;
    left: 0px;
    top: 140px;
    z-index:-1;
    background: url(/img/bg.svg);
    transform: matrix(1, 0, 0, -1, 0, 0);

    @media (max-width: 800px){
        display:flex;
    }
`;

const Profile = ({auth, setCustomerUser}) => {

    const [loading, setLoading] = useState(false);

    const [profile, setProfile] = useState(true);
    const [order, setOrder] = useState(true);
    const [color, setColor] = useState('active');
    const [ncolor, setnColor] = useState('');

    const [user, setUser] = useState({});
    const [edit, setEdit] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(-1);
    const [error, setError] = useState('');

    const [orders, setOrders] = useState([]);
    const [searchText, setSearchText] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(12);
    const [pageCount, setPageCount] = useState(1);
    const [totalResultsCount, setTotalResultsCount] = useState(0);
    const [currentResultsCount, setCurrentResultsCount] = useState(0);
    const [canvasWidth, setCanvasWidth] = useState(0);


    useEffect(() => {
        handleResize();
    });
    const handleResize = () => {
        setCanvasWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
      
    };
    useEffect(() => {
        getProfile(auth.customer_id, auth.token);
        if (window.innerWidth < 800) {
            setOrder(false);
            setProfile(true);
        }
    
    }, []);

    useEffect(() => search(searchText), [searchText, currentPage]);

    const getProfile = (id, token) => {
        getCustomerProfile(id, token)
            .then(result => {
                setUser({...result});
                // setCustomerUser({...result});
            })
            .catch(error => console.error(error));
    };

    const updateProfile = userInfo => {
        console.log(userInfo);

        let params = {};
        if (userInfo?.first_name) params.first_name = userInfo?.first_name;
        if (userInfo?.last_name) params.last_name = userInfo?.last_name;
        if (userInfo?.email) params.email = userInfo?.email;
        if (userInfo?.password) params.password = userInfo?.password;
        if (userInfo?.confirm_password) params.confirm_password = userInfo?.confirm_password;

        params.contact = userInfo?.contact?.replace(/-/g, '');
        params.whatsapp = userInfo?.whatsapp?.replace(/-/g, '');

        // if password and not confirm password, instantly show error

        updateCustomerProfile(auth.customer_id, auth.token, params)
            .then(result => {
                console.log(result);

                // Notify that account updated
                setEdit(false);
                getProfile(auth.customer_id, auth.token);
            })
            .catch(error => {
                console.error(error, error.message);
                // setError(error);
            });
    };


    const search = searchText => {
        window.scrollTo(0, 0);
        setLoading(true);
        getCustomerOrders(auth.customer_id, auth.token, searchText, currentPage, pageLimit)
            .then(result => {
                setOrders([...result.data]);
                setCurrentResultsCount(result.results);
                setTotalResultsCount(result.total);
                setPageCount(Math.ceil(result.total / pageLimit));
            })
            .catch(error => console.error(error))
            .finally(() => setLoading(false));
    };

    const debouncedSearchText = _.debounce(query => setSearchText(query), 400);

    const onSearchTextChange = e => {
        const value = e.target.value.trim();
        debouncedSearchText(value);
    };

    const changePage = direction => {
        if (currentPage === 1 && direction < 0) return;
        if (currentPage === pageCount && direction > 0) return;

        setOrders([]);
        setCurrentPage(currentPage + (direction));
    };

    const retrieveMedia = variant => {
        let src = null;
        if (variant.media && variant.media.length) {
            for (let i = 0; i < variant.media.length; i++) {
                if (variant.media[i].type === 'image') {
                    src = getResourceFile(variant.media[i].resource);
                    break;
                }
            }
        }

        if (!src) {
            if (variant.product.media && variant.product.media.length) {
                for (let i = 0; i < variant.product.media.length; i++) {
                    if (variant.product.media[i].type === 'image') {
                        src = getResourceFile(variant.product.media[i].resource);
                        break;
                    }
                }
            }
        }

        return src;
    };

    const processOrderStatus = status => {
        if (status === 'new') return 'new';
        if (status === 'processing' || status === 'customer_arrived' || status === 'package_ready') return 'open';
        if (status === 'cancelled') return 'cancelled';
        if (status === 'customer_paid') return 'fulfilled';
        else return 'open';
    };

    return (
        <>
            {loading ?
                <LoadingComponent/>
                :
                <>
                    <>
                        <HeaderBackground/>
                        <Gradient/>
                        <MainContainer>
                            <VerticalContainer>

                                <Head>My Account</Head>
                                <Container>
                                    <ProfileHead className={ncolor} onClick={() => {
                                        setOrder(true);
                                        setProfile(false);               
                                        setColor('');
                                        setnColor('next--active');
                                    }}>My Orders</ProfileHead>
                                    <ProfileHeader className={color} onClick={() => {
                                        setProfile(true);
                                        setOrder(false);
                                        setColor('active');
                                        setnColor('');
                                    }}>My Profile</ProfileHeader>
                                </Container>
                            </VerticalContainer>
                        </MainContainer>
                    </>
                    <Layout>
                        {canvasWidth > 768 ?
                            <DotsComponent/>
                            :
                            null
                        }
                    
                        {profile ? 
                        <ProfileContainer>
                            <LayoutHeader>My Profile</LayoutHeader>

                            {!edit ?
                                <Card>
                                    <Header>{user.first_name || ''} {user.last_name || ''}</Header>
                                    <EditLayout>
                                        {user.type && <span>{`${user.type.charAt(0)
                                            .toUpperCase()}${user.type.slice(1)}`}</span>}
                                        <img onClick={() => setEdit(true)} style={{cursor: 'pointer'}} src="/icons/edit.svg"/>
                                    </EditLayout>
                                    <Divider/>
                                    <Title style={{marginTop: 'var(--space-40)'}}>Email</Title>
                                    <Text>{user.email}</Text>
                                    <Title>Contact</Title>
                                    <Text>{formatPhoneNumber(user.contact)}</Text>
                                    <Title>Whatsapp</Title>
                                    <Text>{formatPhoneNumber(user.whatsapp)}</Text>
                                    <Title>Password</Title>
                                    <Text>*************</Text>
                                    <Divider style={{marginTop: 'var(--space-40)'}}/>
                                    <CheckboxRow style={{marginTop: 'var(--space-40)'}}>
                                        <label htmlFor="promotions_cb">Send me emails about sales and promotions</label>
                                        <CustomCheckbox type="checkbox" name="promotions_cb" id="promotions_cb" checked/>
                                    </CheckboxRow>
                                    <CheckboxRow>
                                        <label htmlFor="orders_cb">Send me emails reminding me of order pickups</label>
                                        <CustomCheckbox type="checkbox" name="orders_cb" id="orders_cb" checked/>
                                    </CheckboxRow>
                                    <CheckboxRow>
                                        <label htmlFor="products_cb">Send me emails regarding new products</label>
                                        <CustomCheckbox type="checkbox" name="products_cb" id="products_cb" checked/>
                                    </CheckboxRow>
                                </Card>
                                : <EditComponent userInfo={{...user}} updateProfile={updateProfile} error={error} setEdit={setEdit}/>
                            }
                        </ProfileContainer>
                        :
                        null
                        }
                        {order ? 
                        <OrderContainer>
                            <LayoutHeader>My Orders</LayoutHeader>
                            <Card>
                                <div className="header">
                                    <TopOrderLayout>
                                        <Header>Order History</Header>
                                        <Search onChange={onSearchTextChange} type="search" placeholder="Search Orders..."/>
                                    </TopOrderLayout>

                                    <TopSortLayout>
                                        <span>{`${totalResultsCount} Order${totalResultsCount === 1 ? '' : 's'}`}</span>
                                        <HorizontalLayout>
                                            
                                            <DropdownContainer DropdownWidth={"6rem"}>
                                                <option>Sort By</option>
                                            </DropdownContainer>
                                            <DropdownContainer DropdownWidth={"6rem"}>
                                                <option>Filters</option>
                                            </DropdownContainer>
                                        </HorizontalLayout>
                                    </TopSortLayout>
                                </div>
                                {
                                    orders.map((order, index) =>
                                        <>
                                        {canvasWidth > 500 ? 
                                            <OverviewLineItem
                                                key={`ProfileOrderLineItem_${index}`}
                                                onClick={() => {
                                                    if (selectedOrder !== index) setSelectedOrder(index);
                                                    else setSelectedOrder(-1);
                                                }}
                                                selected={selectedOrder === index}
                                            >
                                                <div className="details">
                                                    <div className="OrderRow">
                                                        <span className="order" style={{paddingLeft:"0.3rem"}}>{`Order #${padding(order.ticket || 0, 8)}`}</span>
                                                        <span className={processOrderStatus(order.status)}>{processOrderStatus(order.status)}</span>
                                                    </div>
                                                    <div className="PriceRow">
                                                        <span className="price">{formatPrice(order.cartTotal)}</span>
                                                        <span className="date" style={{paddingLeft:"0.3rem"}}>{formatDate(order.created, 'MMM D, YYYY')}</span>
                                                    </div>
                                                    <ChevronImage selected={selectedOrder === index} src="/icons/chevron_right.svg"/>
                                                </div>
                                            </OverviewLineItem>
                                            :
                                            <OverviewLineItem
                                                key={`ProfileOrderLineItem_${index}`}
                                                onClick={() => {
                                                    if (selectedOrder !== index) setSelectedOrder(index);
                                                    else setSelectedOrder(-1);
                                                }}
                                                selected={selectedOrder === index}
                                            >
                                            <div className="details">
                                                <div className="OrderRow">
                                                    <span className="order" style={{paddingLeft:"0.3rem"}}>{`Order #${padding(order.ticket || 0, 8)}`}</span>
                                                    <span className="date" style={{paddingLeft:"0.3rem"}}>{formatDate(order.created, 'MMM D, YYYY')}</span>
                                                    
                                                </div>
                                                <div className="PriceRow">
                                                    <span className={processOrderStatus(order.status)}>{processOrderStatus(order.status)}</span>
                                                    <span className="price">{formatPrice(order.cartTotal)}</span>
                                                </div>
                                                <ChevronImage selected={selectedOrder === index} src="/icons/chevron_right.svg"/>
                                            </div>
                                        </OverviewLineItem>
                                            }

                                            {
                                                (selectedOrder === index) && <SelectedOrderContainer>
                                                    {
                                                        order.variants.map((variant, index) => {
                                                            const media = retrieveMedia(variant.variant);
                                                            return <SelectedOrderLineItem key={`SelectedOrderLineItem_${index}`}>
                                                                <ProductImageContainer>
                                                                    {media && <img src={media}/>}
                                                                    <div className="badge">{variant.quantity}</div>
                                                                </ProductImageContainer>
                                                                <div className="details configuration">
                                                                    <span><b>{variant.variant.product.brand.name}</b>{` ${variant.variant.product.name}`}{`${variant.variant.description ? `, ${variant.variant.description}` : ''}`.trim()}</span>
                                                                    <span>
                                                            {(variant.variant.product.attribute_name && variant.variant.attribute) && <>{variant.variant.attribute}</>}
                                                                        {(variant.variant.product.attribute_name && variant.variant.attribute && variant.variant.product.size_name && variant.variant.size) && <>, </>}
                                                                        {(variant.variant.product.size_name && variant.variant.size) && <>{variant.variant.size}</>}
                                                        </span>
                                                                </div>

                                                                <div className="details pricing">
                                                                    <span className="price">{formatPrice(variant.total)}</span>
                                                                    <span className="quantity">Qty: {variant.quantity}</span>
                                                                </div>
                                                            </SelectedOrderLineItem>;
                                                        })
                                                    }
                                                    <div className="buttons">
                                                        {order.status !== 'cancelled' && <button>Email Invoice</button>}
                                                        <button className="repeat">Repeat Order</button>
                                                        {
                                                            (order.status === 'new' || order.status === 'processing' && (order.status !== 'cancelled')) &&
                                                            <button className="cancel">Cancel Order</button>
                                                        }
                                                    </div>
                                                </SelectedOrderContainer>
                                            }
                                        </>
                                    )
                                }
                                <PaginationContainer>
                                    <PaginationComponent
                                        currentPage={currentPage}
                                        pageCount={pageCount}
                                        pageBack={() => changePage(-1)}
                                        pageNext={() => changePage(1)}
                                    />
                                </PaginationContainer>
                            </Card>
                        </OrderContainer>
                        :
                        null   
                    }
                    </Layout>
                </>
            }
        </>
    );
};

function EditComponent({userInfo, updateProfile, error, setEdit}) {
    const ErrorDisplay = styled.span`
        margin-top: var(--space-40);
        margin-bottom: var(--space-56);
        
        color: var(--color-red-600);
        
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-14);
        line-height: var(--font-18);
    `;

    const [user, setUser] = useState({...userInfo});
    const [saveDisabled, setSaveDisabled] = useState(true);

    const handleChange = e => {
        const {value, name} = e.target;
        setUser({
            ...user,
            [name]: value
        });

        if (saveDisabled) setSaveDisabled(false);
    };

    return (
        <Card>
            <Header>Edit User Details</Header>
            <Title>First Name</Title>
            <EditProfileTextInput type="text" name="first_name" value={user.first_name || ''} onChange={handleChange}/>
            <Title>Last Name</Title>
            <EditProfileTextInput type="text" name="last_name" value={user.last_name || ''} onChange={handleChange}/>
            <Title>Account Type</Title>
            <EditProfileDropdown name="type" value={user.type || 'individual'}>
                <option value="individual">Individual</option>
                <option value="company">Company</option>
            </EditProfileDropdown>
            <Title style={{marginTop: '5.5rem'}}>Email</Title>
            <EditProfileTextInput type="email" name="email" value={user.email || ''} onChange={handleChange}/>
            {/*<Title>Confirm Email</Title>*/}
            {/*<EditProfileTextInput type="email"/>*/}
            <Title style={{marginTop: '5.5rem'}}>Contact</Title>
            <MaskedInputComponent
                mask="999-999-9999"
                value={user.contact || ''}
                onChange={handleChange}
                children={() => <EditProfileTextInput name="contact" type="text"/>}
            />
            <Title>Whatsapp</Title>
            <MaskedInputComponent
                mask="999-999-9999"
                value={user.whatsapp || ''}
                onChange={handleChange}
                children={() => <EditProfileTextInput name="whatsapp" type="text"/>}
            />
            <Title style={{marginTop: '5.5rem'}}>Password</Title>
            <EditProfileTextInput name="password" type="password" onChange={handleChange}/>
            <Title>Confirm Password</Title>
            <EditProfileTextInput name="confirm_password" style={{marginBottom: 'var(--space-56)'}} type="password" onChange={handleChange}/>

            {error && <ErrorDisplay text={error}>{error}</ErrorDisplay>}

            <ActionsBar>
                <button disabled={saveDisabled} onClick={() => updateProfile(user)}>Save Changes</button>
                <button onClick={() => setEdit(false)}>Cancel</button>
            </ActionsBar>
        </Card>
    );
}

const mapStateToProps = state => ({auth: state.auth});
const mapDispatchToProps = {
    setCustomerUser: setUser
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
